import {
  GsCustomPermissions,
  type GsPermission,
  GsResources,
} from '../permission-list'

export const allPermissions = GsResources.flatMap((resource) => {
  return [
    ...GsCustomPermissions,
    ...['Create', 'Read', 'Update', 'Delete'].map((action) => {
      return `${resource}:${action}` as GsPermission
    }),
  ]
})

const readonlyPermissions = GsResources.flatMap((resource) => {
  return ['Read'].map((action) => {
    return `${resource}:${action}` as GsPermission
  })
})

export const AdminRolePermissions = allPermissions satisfies GsPermission[]

export const ViewerRolePermissions = [
  ...readonlyPermissions,
  'Checkins:Create',
  'Checkins:Update',
  'OwnedAoaContent:CRUD',
] satisfies GsPermission[]

export const NoAccessRolePermissions = [] satisfies GsPermission[]
